import { createState, State, useState } from '@hookstate/core';
import { getStudios } from '@services/queries/identificationRequests/getStudios';

import { createContext } from 'react';
import { useQuery } from 'react-query';
import { FilterRaw } from './Filter.raw';

interface IFilterContext {
  searchValue: State<string>;
}

export const FilterContext = createContext<IFilterContext>({
  searchValue: createState<string>(''),
});

const FilterQuery = () => {
  const searchValue = useState<string>('');

  const { data: studioFilters } = useQuery(['assets', searchValue.get()], () =>
    getStudios({
      search: searchValue.get(),
    }),
  );

  return (
    <FilterContext.Provider value={{ searchValue }}>
      <FilterRaw studios={studioFilters} />
    </FilterContext.Provider>
  );
};

export { FilterQuery };
